import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import TabItem from "../../common/Tab/TabItem";
import TabContent from "../../common/Tab/TabContent";
import ClientService from "../../../services/ClientService";
import RecipesService from "../../../services/RecipesService";
import GroceriesService from "../../../services/GroceriesService";
import PlanService from "../../../services/PlanService";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { PlusIcon } from "@heroicons/react/outline";

const MySwal = withReactContent(Swal)

const Plans = () => {
    let { clientId, planId } = useParams();
    const [shouldLoad, setShouldLoad] = useState(true)
    const [plansData, setPlansData] = useState([null])
    const [selectedClients, setSelectedClients] = useState([{}])
    const [mappedTabList, setMappedTabList] = useState(null)
    const [mappedTabContent, setMappedTabContent] = useState(null)
    const [newnoOfRows, setNewNoOfRows] = useState([4]);
    const [newnoOfCommentRows, setNewNoCommentOfRows] = useState([1]);
    const [clientsData, setClientsData] = useState([])
    const [openTab, setOpenTab] = useState(1);
    const [options, setOptions] = useState([]);
    const emptyPlan = {
        monday: [],
        tuesday: [],
        wednesday: [],
        thursday: [],
        friday: [],
        saturday: [],
        sunday: [],
        times: [],
        comments: []
    }

    useEffect(() => {
        if (shouldLoad) {
            setShouldLoad(false);
            getClients();
            loadDefaultData();
            getOptions();
        }

        mapTabs()
    }, [clientsData, selectedClients, plansData, newnoOfRows, newnoOfCommentRows, options])


    const getOptions = () => {
        RecipesService.getRecipes().then(response => {
            let data = response.data.map(recipe => {
                recipe.value = recipe.name
                recipe.label = recipe.name
                recipe.recipeItems.map((item) => {
                    item.label = item.ingredient.name;
                    item.value = item.ingredient.name;
                    return item;
                });
                return recipe
            })
            GroceriesService.getSGroceriesUrl().then((response) => {
                let tempData = response.data.map((item) => {
                    let groceryForSelect = { ingredient: { ...item } };
                    groceryForSelect.label = item.name;
                    groceryForSelect.ingredient.label = item.name;
                    groceryForSelect.value = item.name;
                    groceryForSelect.ingredient.value = item.name;
                    return groceryForSelect;
                });
                let temp = [...data, ...tempData]
                setOptions(temp);
            });
        })
    }

    const getClients = () => {
        ClientService.getClientsShort().then((response) => {
            let data = response.data.map(client => {
                let temp = { ...client }
                temp.value = client.name
                temp.label = client.name
                return temp
            })
            setClientsData(data)
        })
    };

    const mapTabs = () => {
        mapTabList()
        mapTabContent()
    }

    const loadDefaultData = () => {
        if ((planId && planId !== ":planId") && (clientId && clientId !== ":clientId")) {
            PlanService.getPlan(planId).then(response => {
                setPlanDataOnLoad(response, 0)
            });
            ClientService.getClient(clientId).then((response) => {
                let data = { ...response.data,
                    value: response.data.name,
                    label: response.data.name,
                }
                let tempClients = [data]
                setSelectedClients(tempClients);
            });
        } else if (clientId && clientId !== ":clientId") {
            PlanService.getLastByClientId(clientId).then(response => {
                setPlanDataOnLoad(response, 0)
            });

            ClientService.getClient(clientId).then((response) => {
                let data = {
                    ...response.data,
                    value: response.data.name,
                    label: response.data.name,
                }
                let tempClients = [data]
                setSelectedClients(tempClients);
            });
        }
    }

    const setPlanDataOnLoad = (response, index) => {
        let rows = response.data.times ? response.data.times.length : 0;
        let commentRows = response.data.comments ? response.data.comments.length : 0;

        let tempRows = newnoOfRows;
        tempRows[index] = rows;
        let tempComments = newnoOfCommentRows;
        tempComments[index] = commentRows;
        let tempPlanData = plansData;
        tempPlanData[index] = response.data;
        setPlansData([...tempPlanData]);
        setNewNoOfRows([...tempRows]);
        setNewNoCommentOfRows([...tempComments]);
    }

    const newsavePlan = (index) => {
        plansData[index].clientId = selectedClients[index].id
        PlanService.updatePlan(plansData[index]).then(response => {
            console.log(response)
            MySwal.fire({
                title: "Successfully saved plan",
                showCancelButton: true,
                showDenyButton: false,
                showConfirmButton: false,
                cancelButtonText: `Close`,
            })
        })
    }

    const newaddPlan = (index) => {
        plansData[index].clientId = selectedClients[index].id
        plansData[index].id = undefined
        PlanService.addPlan(plansData[index]).then(response => {
            let tempPlanData = plansData;
            tempPlanData[index] = response.data;
            setPlansData([...tempPlanData]);
            MySwal.fire({
                title: "Successfully created new plan",
                showCancelButton: true,
                showDenyButton: false,
                showConfirmButton: false,
                cancelButtonText: `Close`,
            })
        })
    }
    const newsendPlan = (index) => {
        plansData[index].clientId = selectedClients[index].id
        PlanService.sendPlan(plansData[index]).then(response => {
            console.log(response)
            MySwal.fire({
                title: "Successfully sent plan",
                showCancelButton: true,
                showDenyButton: false,
                showConfirmButton: false,
                cancelButtonText: `Close`,
            })
        })
    }

    const newselectClient = (client, index) => {
        let temp = [...selectedClients]
        temp[index] = client
        setSelectedClients(temp)
        PlanService.getLastByClientId(client.id).then(response => {
            if (response && response.data) {
                setPlanDataOnLoad(response, index)
            } else {
                MySwal.fire({
                    title: "Ovaj klijent nema prethodnih planova. Kada zavrsite kreiranje prvog plana iskoristite 'Create new plan' opciju umesto save.",
                    showCancelButton: true,
                    showDenyButton: false,
                    showConfirmButton: false,
                    cancelButtonText: `Close`,
                })
                emptyPlan.clientId = client.id
                let tempRows = newnoOfRows
                tempRows[index] = 4
                let tempComments = newnoOfCommentRows
                tempComments[index] = 0
                let tempPlanData = plansData
                tempPlanData[index] = emptyPlan
                setNewNoOfRows([...tempRows])
                setNewNoCommentOfRows([...tempComments])
                setPlansData([...tempPlanData])
            }
        })
    }

    const selectPlan = (id, index) => {
        PlanService.getLastByClientId(id).then(response => {
            if (response && response.data) {
                setPlanDataOnLoad(response, index)
            } 
        })
    }

    const addTab = () => {
        let temp = [...selectedClients]
        temp.push({})
        setSelectedClients(temp)

        let tempRows = newnoOfRows
        tempRows.push(4)

        let tempComments = newnoOfCommentRows
        tempComments.push(0)

        let tempPlanData = plansData
        tempPlanData.push(emptyPlan)

        setNewNoOfRows([...tempRows])
        setNewNoCommentOfRows([...tempComments])
        setPlansData([...tempPlanData])
    }


    const removeTab = (index) => {
        let temp = [...selectedClients]
        temp.splice(index, 1)
        setSelectedClients(temp)

        let tempPlanData = plansData
        tempPlanData.splice(index, 1)
        setPlansData([...tempPlanData])
    }

    const setNewPlanData = (planData, index) => {
        let tempPlanData = plansData
        tempPlanData[index] = { ...planData }
        setPlansData([...tempPlanData])
    }

    const setNewNOR = (rows, index) => {
        let tempRows = newnoOfRows
        tempRows[index] = rows
        setNewNoOfRows([...tempRows])
    }

    const setNewCNOR = (rows, index) => {
        let tempRows = newnoOfCommentRows
        tempRows[index] = rows
        setNewNoCommentOfRows([...tempRows])
    }



    const mapTabList = () => {
        let tempClients = [...selectedClients]
        let mappedListItems = tempClients.map((client, index) => {
            return (<Tab key={index}><TabItem key={index} openTab={openTab} removeTab={removeTab} setOpenTab={setOpenTab} clients={clientsData} selectedClient={client} setSelectedClient={newselectClient} index={index}></TabItem></Tab>);
        })
        let mappedTemp = (
            <TabList>
                {mappedListItems}
                <button type="button" className="rounded-full  w-6 h-6 p-1  bg-blueSecondary ml-3 text-white  transform hover:rotate-90 transition" onClick={() => { addTab() }}><PlusIcon /></button>
            </TabList>
        )
        setMappedTabList(mappedTemp)
    }

    const mapTabContent = () => {
        let tempPlans = [...plansData]
        let tempContent = tempPlans.map((plan, index) => {
            return (
                <TabPanel key={index}>
                    <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
                        <div className="">
                            <div className="tab-content tab-space">
                                <TabContent key={index}
                                    planIndex={index}
                                    openTab={openTab}
                                    planData={plan}
                                    options={options}
                                    setPlanData={setNewPlanData}
                                    sendPlan={newsendPlan}
                                    addPlan={newaddPlan}
                                    savePlan={newsavePlan}
                                    noOfRows={newnoOfRows[index]}
                                    setNoOfRows={setNewNOR}
                                    noOfCommentRows={newnoOfCommentRows[index]}
                                    setNoCommentOfRows={setNewCNOR}
                                    selectExistingClientsPlan={selectPlan}
                                    clients={clientsData}> </TabContent>
                            </div>
                        </div>
                    </div>
                </TabPanel>
            );
        })
        setMappedTabContent(tempContent)
    }


    return (
        <>
            <div className="flex flex-wrap">
                <div className="w-full">
                    <Tabs>
                        {mappedTabList}
                        {mappedTabContent}
                    </Tabs>
                </div>
            </div>
        </>
    );
};


export default function TabsRender() {
    return (
        <>
            <Plans />
        </>
    );
}